import defaultAttributes from '../defaultAttributes';

const CornerUpLeft = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '9 14 4 9 9 4' }],
    ['path', { d: 'M20 20v-7a4 4 0 00-4-4H4' }],
  ],
];

export default CornerUpLeft;
